import './index.css'
import clsx from 'clsx'

import React from 'react'
import { LuChevronDown } from '@react-icons/all-files/lu/LuChevronDown'
import { Button } from 'components/ds'
type Props = {
  onClick: (...args: Array<any>) => any
  open: boolean
  count: number
}

const TrackVersionsButton = ({
  onClick,
  open,
  count,
}: Props): React.ReactElement => {
  return (
    <Button
      className="ExplorerTrackVersionsButton"
      variant="ghost"
      color="gray"
      highContrast
      radius="full"
      size="1"
      onClick={e => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      {count}
      <LuChevronDown
        className={clsx('ExplorerTrackVersionsButton__Arrow', {
          'ExplorerTrackVersionsButton__Arrow--Open': open,
        })}
        size={20}
      />
    </Button>
  )
}

export default TrackVersionsButton
